import { attemptToJoinExam, examDatails } from "../api/userActions";
import { getSessionToken, getStoredUserSession } from "./utils";

function readStoredQuizToken(quizCode) {
    const session = getStoredUserSession({ quizCode });
    return getSessionToken(session);
}

function navigateToExamRoute(navigate, quizCode, examData) {
    const q = quizCode;
    if (examData.type === "test" && examData.question_type === "custom") {
        navigate(`/quiz/test/${q}`, { replace: true });
        window.location.reload();
        return true;
    }
    if (examData.type === "mixed" && examData.question_type === "custom") {
        navigate(`/quiz/mixed/${q}`, { replace: true });
        window.location.reload();
        return true;
    }
    if (examData.type === "test" && examData.question_type === "pdf") {
        navigate(`/quiz/test-pdf/${q}`, { replace: true });
        window.location.reload();
        return true;
    }
    if (examData.type === "descriptive" && examData.question_type === "custom") {
        navigate(`/quiz/descriptive/${q}`, { replace: true });
        window.location.reload();
        return true;
    }
    if (examData.type === "descriptive" && examData.question_type === "pdf") {
        navigate(`/quiz/descriptive-pdf/${q}`, { replace: true });
        window.location.reload();
        return true;
    }
    return false;
}

async function loadExamAndJoin(quizCode, quizToken) {
    const data = await examDatails(quizCode);
    if (data?.status === "not-found" || !data?.quiz) {
        return { ok: false, examData: null, joinResult: null, examDataResult: data };
    }
    const join = await attemptToJoinExam(quizCode, quizToken);
    if (join?.status === "attempt-finished") {
        return { ok: false, examData: data.quiz, joinResult: join, examDataResult: data, finished: true };
    }
    if (join?.status !== "joined") {
        return { ok: false, examData: data.quiz, joinResult: join, examDataResult: data };
    }
    return { ok: true, examData: data.quiz, joinResult: join, examDataResult: data };
}

/**
 * اگر در همین مرورگر توکن معتبر آزمون باشد و join موفق شود، مستقیم به صفحهٔ آزمون می‌رود.
 * @returns {Promise<{entered: boolean, joinResult: any, examData: any}>}
 */
export async function tryEnterExamWithStoredToken(navigate, quizCode) {
    try {
        const quizToken = readStoredQuizToken(quizCode);
        if (!quizToken) {
            return { entered: false, joinResult: null, examData: null };
        }
        const r = await loadExamAndJoin(quizCode, quizToken);
        if (r.finished) {
            navigate(`/quiz/finish`, { replace: true });
            return { entered: true, joinResult: r.joinResult, examData: r.examData };
        }
        if (!r.ok) {
            return { entered: false, joinResult: r.joinResult, examData: r.examData };
        }
        const ok = navigateToExamRoute(navigate, quizCode, r.examData);
        return { entered: ok, joinResult: r.joinResult, examData: r.examData };
    } catch {
        return { entered: false, joinResult: null, examData: null };
    }
}

/**
 * پس از ذخیرهٔ توکن مهمان: join به آزمون و در صورت موفقیت، هدایت مستقیم به صفحهٔ آزمون؛
 * در غیر این صورت به صفحهٔ اطلاعات آزمون.
 *
 * اگر `redirectOnFailure` برابر false باشد، در صورت ناموفق بودن join، هدایت انجام نمی‌شود
 * تا فراخواننده بتواند پیام خطای مناسب را نمایش دهد.
 *
 * @returns {Promise<{entered: boolean, joinResult: any, examData: any}>}
 */
export async function redirectGuestToExamOrJoinPage(navigate, quizCode, options = {}) {
    const { redirectOnFailure = true } = options;
    try {
        const quizToken = readStoredQuizToken(quizCode);
        if (!quizToken) {
            if (redirectOnFailure) navigate(`/guest/join/${quizCode}`, { replace: true });
            return { entered: false, joinResult: null, examData: null };
        }
        const r = await loadExamAndJoin(quizCode, quizToken);
        if (r.finished) {
            navigate(`/quiz/finish`, { replace: true });
            return { entered: true, joinResult: r.joinResult, examData: r.examData };
        }
        if (r.ok && navigateToExamRoute(navigate, quizCode, r.examData)) {
            return { entered: true, joinResult: r.joinResult, examData: r.examData };
        }
        if (redirectOnFailure) navigate(`/guest/join/${quizCode}`, { replace: true });
        return { entered: false, joinResult: r.joinResult, examData: r.examData };
    } catch {
        if (redirectOnFailure) navigate(`/guest/join/${quizCode}`, { replace: true });
        return { entered: false, joinResult: null, examData: null };
    }
}
